// MA-891 — badge ids, families and the practice-day ladder (KID-JOURNEY-2026-10-08 §5).
// Pure: no React, no storage. Every name string a badge can carry is built here
// (allBadgeNameStrings in index.ts enumerates them for the deny-list test).

export type BadgeFamily = "skill" | "chapter" | "days";

/** The seven practice-day thresholds (D-KJ-5). */
export const PRACTICE_DAY_THRESHOLDS = [1, 3, 7, 14, 30, 50, 100] as const;
export type PracticeDayThreshold = (typeof PRACTICE_DAY_THRESHOLDS)[number];

/** The thresholds that repeat at every multiple (founder, 2026-10-08). */
export const REPEATING_DAY_THRESHOLDS: ReadonlySet<number> = new Set([7, 14]);

export const skillBadgeId = (skillId: string): string => `skill:${skillId}`;
export const chapterBadgeId = (trophy: string): string => `chapter:${trophy}`;
export const daysBadgeId = (n: number): string => `days:${n}`;
/** A repeat instance: `days:7#2` is the second time the 7-day badge is held. */
export const daysInstanceId = (n: number, instance: number): string => `days:${n}#${instance}`;
/** The stage record of a skill badge (D-KJ-11 key shape, written by MA-892). */
export const skillStageId = (skillId: string, stage: "silver" | "gold"): string => `skill:${skillId}:${stage}`;
